import { ChangeDetectionStrategy, Component } from "@angular/core";

import { PortalModule } from "@angular/cdk/portal";
import { MatSidenavModule } from "@angular/material/sidenav";
import { RouterOutlet } from "@angular/router";
import { CorelyToolbarComponent } from "../components/corely-toolbar/corely-toolbar.component";
import { FooterComponent } from "../components/footer/footer.component";

@Component({
	selector: "corely-layout",
	templateUrl: "./corely-layout.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CorelyToolbarComponent, RouterOutlet, MatSidenavModule, PortalModule, FooterComponent]
})
export class CorelyLayoutComponent {}
